import { isLiveSession } from '../../_shared/domain/enrichment-status.domain';
import { type EnrichmentSession } from '../../_shared/domain/session.domain';

// The base session contract now lives in `_shared` so `session-detail` can extend
// it without importing from this feature. Re-exported here so the sessions slice's
// internal imports keep resolving from `../domain/sessions.domain`.
export { type EnrichmentSession,enrichmentSessionSchema } from '../../_shared/domain/session.domain';

/** True when at least one session is still live (drives auto-refresh). */
export function hasRunningSession(sessions: EnrichmentSession[]): boolean {
  return sessions.some((s) => isLiveSession(s));
}
